const apiBasePath = '/umbraco/surface/TrustPilotSurface/';

const fetchBaseConfig: RequestInit = {
  credentials: 'same-origin',
  headers: {
    'content-type': 'application/json',
    accept: 'application/json',
  },
};

export const getAverageStarRating = (productSku?: string | null) => {
  const path = `${apiBasePath}GetProductReviewSummary/?productSku=${productSku}`;
  return fetch(path, fetchBaseConfig).then(response => {
    return response.json();
  });
};
